import type { Theme } from '@/types/theme';
import { ENDPOINTS } from '@/constants/endpoints';

import { get, upload, post, download } from './client';

export const themeService = {
  getTheme: async (): Promise<Theme> => {
    return get<Theme>(ENDPOINTS.THEMES.CURRENT);
  },
  uploadPreviewTheme: async (file: File): Promise<Theme> => {
    return upload<Theme>(ENDPOINTS.THEMES.UPLOAD_PREVIEW, file);
  },
  applyTheme: async (themeName: string, uploadId?: string): Promise<void> => {
    return post<void>(ENDPOINTS.THEMES.APPLY, { themeName, uploadId });
  },
  downloadTheme: async (): Promise<void> => {
    const theme = await get<Theme>(ENDPOINTS.THEMES.CURRENT);
    const fileName = `${theme.name}.zip`;
    return download(ENDPOINTS.THEMES.DOWNLOAD, fileName);
  },
};
